var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model.number",
        value: _vm.inputValue,
        expression: "inputValue",
        modifiers: { number: true },
      },
    ],
    ref: "htmlInput",
    staticClass: "pui-form-input-field",
    class: _vm.dynamicClasses,
    attrs: {
      type: "number",
      step: _vm.step,
      min: _vm.min,
      max: _vm.max,
      disabled: _vm.isDisabled,
      readonly: _vm.isDisabled,
      required: _vm.required,
    },
    domProps: { value: _vm.inputValue },
    on: {
      input: function ($event) {
        if ($event.target.composing) return
        _vm.inputValue = _vm._n($event.target.value)
      },
      blur: function ($event) {
        return _vm.$forceUpdate()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }